import { render, staticRenderFns } from "./GetRewardModal.vue?vue&type=template&id=3fe2dd46&scoped=true"
import script from "./GetRewardModal.vue?vue&type=script&lang=js"
export * from "./GetRewardModal.vue?vue&type=script&lang=js"
import style0 from "./GetRewardModal.vue?vue&type=style&index=0&id=3fe2dd46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe2dd46",
  null
  
)

export default component.exports